import React, { FC, MouseEventHandler } from 'react';

interface DownloadButtonProps {
  className: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
}

export const DownloadButton: FC<DownloadButtonProps> = ({ className, onClick }) => {
  return (
    <button onClick={onClick} className={`btn btn-primary btn-sm ${className}`} type="button">
      <span className="fa fa-download"></span>
    </button>
  );
};